import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  private clientChatSelected;

  constructor() { }

  setSelectedClientChat(id: any) {
    this.clientChatSelected = id;
  }
  
  getSelectedClientConversation() {
    return this.clientChatSelected;
  }
}
